import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "../../components/base";
/**
 * A floating button that scrolls to the bottom of scrollable content.
 * Typically used with useScrollToBottom hook.
 *
 * @example
 * ```tsx
 * const { showScrollToBottom, scrollToBottom, scrollContainerRef } = useScrollToBottom()
 *
 * return (
 *   <div className="relative">
 *     <div ref={scrollContainerRef} className="overflow-y-auto">
 *       {content}
 *     </div>
 *     <ScrollToBottomButton
 *       show={showScrollToBottom}
 *       onClick={scrollToBottom}
 *     />
 *   </div>
 * )
 * ```
 */
export const ScrollToBottomButton = ({ show, className, position = "absolute", bottom = "240px", onClick, }) => {
    if (!show)
        return null;
    return (_jsx(Button, { size: "sm", variant: "outline", className: cn(`${position} opacity-70 hover:opacity-100 left-1/2 transform -translate-x-1/2 z-10 rounded-full w-8 h-8 p-0 shadow-lg bg-background/90 backdrop-blur-sm border-2 hover:bg-background animate-in fade-in-0 slide-in-from-bottom-2 duration-200`, className), style: {
            // Apply bottom offset for both absolute and fixed positioning.
            // (Previously only applied for "absolute", which made "fixed" ignore the bottom prop.)
            bottom,
        }, onClick: onClick, children: _jsx(ChevronDown, { className: "h-4 w-4" }) }));
};
//# sourceMappingURL=ScrollToBottomButton.js.map